import { render, staticRenderFns } from "./dynamicButtonContainer.vue?vue&type=template&id=31bcb6a1"
import script from "./dynamicButtonContainer.vue?vue&type=script&lang=js"
export * from "./dynamicButtonContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports